import { organizationConstants } from '../_constants';

export function organizations(state = {}, action) {
    delete state.loading;
    switch (action.type) {
    case organizationConstants.CREATE_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case organizationConstants.CREATE_SUCCESS:
        return {
            ...state,
            loading: false,
            organization: action.organization,
        };
    case organizationConstants.CREATE_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    case organizationConstants.GETDETAIL_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case organizationConstants.GETDETAIL_SUCCESS:
        return {
            ...state,
            loading: false,
            organization: action.organization,
        };
    case organizationConstants.GETDETAIL_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    case organizationConstants.GETALL_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case organizationConstants.GETALL_SUCCESS:
        return {
            ...state,
            loading: false,
            organizations: action.organizations,
        };
    case organizationConstants.GETALL_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    case organizationConstants.UPDATE_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case organizationConstants.UPDATE_SUCCESS:
        return {
            ...state,
            loading: false,
            organization: action.organization,
        };
    case organizationConstants.UPDATE_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    case organizationConstants.DELETE_REQUEST:
        // add 'deleting:true' property to organization being deleted
        return {
            ...state,
            organizations: state.organizations.map(organization =>
                (organization.id === action.id
                    ? { ...organization, deleting: true }
                    : organization)),
        };
    case organizationConstants.DELETE_SUCCESS:
        // remove deleted smoothie from state
        return {
            ...state,
            organizations: state.organizations.filter(organization => organization.id !== action.id),
        };
    case organizationConstants.DELETE_FAILURE:
        // remove 'deleting:true' property and add 'deleteError:[error]' property to organization
        return {
            ...state,
            organizations: state.organizations.map((organization) => {
                if (organization.id === action.id) {
                    // make copy of organization without 'deleting:true' property
                    const { deleting, ...organizationCopy } = organization;
                    // return copy of organization with 'deleteError:[error]' property
                    return { ...organizationCopy, deleteError: action.error };
                }

                return organization;
            }),
        };
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/organizations.reducer.js